import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 20px;
`;

export const Row = styled.div`
  display: flex;
  gap: 15px;
  margin-bottom: 5px;
`;

export const WrapperInputCustom = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;
`;

export const Column = styled.div`
  flex: 1;
`;

export const FieldLabel = styled.label`
  font-size: 12px;
  font-weight: 600;
  font-family: 'Montserrat', sans-serif;
  color: #7b7b7b;
  margin-bottom: 6px;
  display: block;
`;

export const Error = styled.span`
  padding: 5px;
  font-size: 12px;
  text-align: center;
  color: #f27160;
  font-weight: 600;
  font-family: 'Montserrat', sans-serif;
  width: 100%;
  display: block;
  margin-top: 5px;
`;

export const AutocompleteWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const AutocompleteDropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  max-height: 300px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  margin-top: 4px;
`;

export const AutocompleteItem = styled.div`
  padding: 12px 15px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  font-size: 14px;
  color: #333;
  
  &:hover {
    background-color: #f5f5f5;
  }
  
  &:last-child {
    border-bottom: none;
  }
`;

